import {getContactNumber, getSettings} from '../../selectors';
import validateContactNumberForFrasersPlus from './validateContactNumberForFrasersPlus';

export default (state, isToDisableFrasersPlus = false) => {
  const contactNumber = getContactNumber(state);
  const isValidUKContactNumber = validateContactNumberForFrasersPlus(contactNumber);
  
  if (isToDisableFrasersPlus && getSettings(state)?.validate_contact_number_for_frasers_plus_and_disable) {
    return !isValidUKContactNumber;
  }
  
  if (!isToDisableFrasersPlus && getSettings(state)?.validate_contact_number_for_frasers_plus_and_show_message) {
    return !isValidUKContactNumber;
  }
  
  return false;
};
